import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { getGetControlsControlIdQueryOptions } from "api/generated/controls/controls";

export const CONTROL_QUERY_KEY = "control";

const getQueryKey = (controlId: string) => [CONTROL_QUERY_KEY, controlId];
export function useFetchControlQuery() {
    const queryClient = useQueryClient();
    return useCallback(
        async (controlId: string) =>
            queryClient.fetchQuery(
                getGetControlsControlIdQueryOptions(controlId, {
                    query: { queryKey: getQueryKey(controlId) },
                })
            ),
        [queryClient]
    );
}
